<template>
  <table v-if="details" class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}:</label></td>
      <td class="pl-2">{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}:</label></td>
      <td class="pl-2">
        {{ details.status }}
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('seasonTicketRevisions.details.season_ticket_id') }}:</label></td>
      <td class="pl-2">{{ details.season_ticket_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('seasonTicketRevisions.details.fare_group_id') }}:</label></td>
      <td class="pl-2">{{ details.fare_group_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('seasonTickets.details.discount_id') }}:</label></td>
      <td class="pl-2">{{ details.discount_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('seasonTickets.details.municipality_id') }}:</label></td>
      <td class="pl-2">{{ details.municipality_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('seasonTicketRevisions.details.price') }}:</label></td>
      <td class="pl-2">{{ details.price | money }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('seasonTicketRevisions.details.sale_starts_at') }}:</label></td>
      <td class="pl-2">{{ details.sale_starts_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('seasonTicketRevisions.details.sale_ends_at') }}:</label></td>
      <td class="pl-2"><span v-if="details.sale_ends_at">{{ details.sale_ends_at | time }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('seasonTicketRevisions.details.max_start_postpone_days') }}:</label></td>
      <td class="pl-2">{{ details.max_start_postpone_days }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('seasonTicketRevisions.details.requires_additional_details') }}:</label></td>
      <td class="pl-2">{{ details.requires_additional_details }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('seasonTicketRevisions.details.revision') }}:</label></td>
      <td class="pl-2">{{ details.revision }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('seasonTicketRevisions.details.place_of_purchase') }}:</label></td>
      <td class="pl-2">{{ details.place_of_purchase }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}:</label></td>
      <td class="pl-2">{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.createdBy') }}:</label></td>
      <td class="pl-2">{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}:</label></td>
      <td class="pl-2">{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}:</label></td>
      <td class="pl-2">{{ details.modified_by }}</td>
    </tr>
  </table>
</template>
<script>

export default {
  name: "SeasonTicketRevisionDetails",
  props: {
    details: {
      type: Object,
      required: true,
    }
  },
};
</script>
